import React, { createRef } from 'react';

type Props = {
  shouldScroll: boolean;
  offset?: number;
  children: (ref: React.RefObject<any>) => React.ReactNode;
};

export class ScrollToMe extends React.Component<Props> {
  itemRef = createRef<any>();

  componentDidMount() {
    const { shouldScroll, offset } = this.props;
    if (shouldScroll && this.itemRef.current) {
      this.itemRef.current.scrollIntoView();
      if (offset) {
        window.scrollBy(0, offset);
      }
    }
  }

  render() {
    return this.props.children(this.itemRef);
  }
}
